export default __webpack_public_path__ + "static/media/ico-active.59ec1362.svg";